import { Component, inject, input, output } from '@angular/core';
import { MessageTypes } from 'libs/messages/src/lib/models/message.model';
import { MessageTypeIcons } from 'libs/messages/src/lib/services/message-type-icons.lib.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { ClientName } from 'libs/config/client.names';

@Component({
    selector: 'lib-message-types',
    templateUrl: './message-types.component.html',
    styleUrls: ['./message-types.component.scss'],
    imports: [FaIconComponent, NgClass, TranslatePipe]
})
export class MessageTypesComponent {
	protected readonly config = inject<AppConfig>(APP_CONFIG_TOKEN);
	protected readonly ClientName = ClientName;

	readonly messageType = input<MessageTypes>(undefined);
	readonly newMessageType = output<number>();

	MessageTypes = MessageTypes;
	MessageTypeIcons = MessageTypeIcons;

	set newType(type: MessageTypes) {
		this.newMessageType.emit(+type);
	}

}
